import { useCallback, useEffect, useState } from 'react';

export const useSafeState: typeof useState = <S>(initialState?: S | (() => S)) => {
  const [abortController] = useState(new AbortController());
  const [state, setState] = useState<S | undefined>(initialState);
  const { signal } = abortController;

  useEffect(() => () => abortController.abort(), [abortController]);

  const wrappedSetState = useCallback<typeof setState>(
    (s) => void (!signal.aborted && setState(s)),
    [signal],
  );

  return [state, wrappedSetState];
};
